import config from '../config'
import Axios from 'axios'
import types from '../store/globaltypes'
import firebase from 'firebase/app'
import { registerAuthRouteGuard } from '../router'

var base = `${config.wordpressUrl}${config.apiLocation}`
var requestConfig = config.wordpressAuth ? { auth: config.wordpressAuth } : {}

export default {
  setupAuthHandler (router, store) {
    const unsub = firebase.auth().onAuthStateChanged(async res => {
      unsub()
      registerAuthRouteGuard(router, store)
      if (res) {
        const success = await store.dispatch(types.user.actions.loadUser, res.email)
        if (success) {
          store.dispatch(types.crops.actions.fill)
          store.dispatch(types.main.actions.fill)
        } else {
          router.push({ name: 'login' })
        }
      } else {
        router.push({ name: 'login' })
      }
    })
  },
  registerNewUser (loginData) {
    return Axios.post(`${base}/register-new-user`, loginData, requestConfig)
  },
  wordpressAutoLogin () {
    return Axios.post(`${base}/wordpress-auto-login`, {}, requestConfig)
  },
  wordpressLogin (loginData) {
    return Axios.post(`${base}/wordpress-login`, loginData, requestConfig)
  },
  facebookLogin (accessToken) {
    return Axios.post(`${base}/facebook-login`, { accessToken }, requestConfig)
  },
  appleLogin (identityToken) {
    return Axios.post(`${base}/apple-login`, { identityToken }, requestConfig)
  }
}
